import { render, staticRenderFns } from "./roledetail.vue?vue&type=template&id=a96c1384&scoped=true"
import script from "./roledetail.vue?vue&type=script&lang=js"
export * from "./roledetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96c1384",
  null
  
)

export default component.exports